export enum Role {
  Owner,
	Administrator,
  Cashier
}
